import { render } from "./WelcomeBanner.vue?vue&type=template&id=30b12428&scoped=true"
const script = {}

import "./WelcomeBanner.vue?vue&type=style&index=0&id=30b12428&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b12428"]])

export default __exports__